<template>
    <li>
        <router-link id="main-nav-help" to='/help'><span>{{$t("header.mainNav.help")}}</span></router-link>
        <ul class="sub-menu w-250">
            <li :class="{ active: $route.name === 'helpAll' }">
                <router-link to="/help/">
                    <span>{{ $t("header.mainNav.helpAll") }}</span>
                </router-link>
            </li>
            <li>
                <router-link to="/help/self-publishing">
                    <span>{{ $t("header.mainNav.helpSelfPublishing") }}</span>
                </router-link>
            </li>
            <li :class="{ active: $route.name === 'helpProfile' }">
                <router-link to="/help/profile">
                    <span>{{ $t("header.mainNav.helpProfile") }}</span>
                </router-link>
            </li>
            <li :class="{ active: $route.name === 'helpOrders' }">
                <router-link to="/help/orders">
                    <span>{{ $t("header.mainNav.helpOrders") }}</span>
                </router-link>
            </li>
            <li :class="{ active: $route.name === 'helpOther' }">
                <router-link to="/help/other">
                    <span>{{ $t("header.mainNav.helpOther") }}</span>
                </router-link>
            </li>
        </ul>
    </li>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "PrintBookHelpTab",
    computed: {
        ...mapGetters("config", {
            frontConfig: "front",
        }),
    },
};
</script>

<style scoped>

</style>